import React from 'react'

import './Avatar.css'

import avatar from '@assets/avatar.png'

function Avatar() {
	return (
		<div id='avatar'>
			<img src={avatar} alt='avatar' />
		</div>
	)
}

export default Avatar
